import React, { useState } from "react";
import SearchForm from "./SearchForm";
import SearchTitle from "./SearchTitle";

export default React.memo(
  function Search({
    setViewStateInBounds,
    setActiveFeatures,
    setSelectedId,
    setMarkers
  }) {
    /**
     * Popup interactions
     */
    const [showSearch, setShowSearch] = useState(false);

    return (
      <>
        <SearchTitle
          showSearch={() => setShowSearch(true)}
          setSelectedId={setSelectedId}
        />
        <SearchForm
          open={showSearch}
          onClose={() => setShowSearch(false)}
          setViewStateInBounds={setViewStateInBounds}
          setActiveFeatures={setActiveFeatures}
          setSelectedId={setSelectedId}
          setMarkers={setMarkers}
        />
      </>
    );
  },
  () => true
);
